<div class="row">
  <div class="col-7">
    <form libEnterKeyHandler [formGroup]="form" class="parameters-form">
      <app-parameters
        [form]="form"
        [quantityChangedEvent]="quantityChanged"
        (isParametersValid)="onParameterValidation($event)"
      ></app-parameters>
    </form>
    <app-sampling-estimation
      [aqlSampleQuantity]="aqlSampleQuantity"
      [tgsSampleQuantity]="tgsSampleQuantity"
    ></app-sampling-estimation>
  </div>
  <div class="col">
    <ng-container *ngIf="printInfo$ | async as data">
      <app-print-label-list
        [printLabelData]="data"
        [productionOrderId]="productionOrderId"
        (quantityChanged)="onQuantityChanged($event)"
      ></app-print-label-list>
    </ng-container>
  </div>
</div>
